// import tingle from 'tingle.js';
// import ProductHelpers from './base';
import { newModal } from '../components/modal';
import productSlider from '../components/productSlider';
// let wishlist = require('./wishlistHeart');

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} productUrl - url to be used for going to the product details page
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
const fillModalElement = (productUrl, selectedValueUrl, modal) => {
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: html => {
            modal.setContent(html.renderedTemplate);
            $('.product-quickview .carousel-inner').slick({
                arrows: true,
                dots: false
            });
            productSlider();
            // wishlist.highlightIconsForAllItemsInWishlist();
            modal.open();

            localStorage.setItem('prevlisttype', localStorage.getItem('listtype'));
            localStorage.setItem('listtype', 'landing');
            localStorage.setItem('prevlisttypeforcart', localStorage.getItem('listtypeforcart'));
            localStorage.setItem('listtypeforcart', 'landing');
            $('body').trigger('product:productLanding');

            if (document.getElementById('TU')) {
                document.getElementById('TU').click();
            }
            $(modal.modalBox)
                .find('.close-custom')
                .on('click', function (e) {
                    modal.close();
                    modal.destroy();
                });

            const destroyModal = () => {
                try {
                    modal.close();
                    modal.destroy();
                } catch (e) {};
                // remove the event listener to manage cases where the modal
                // is opened two or more times, (removes console error)
                $(document).off('product:afterAddToCart', destroyModal);
            };

            $(document).on('product:afterAddToCart', destroyModal);
        },
        error: err => {
            console.log('Error:', err);
        }
    });
};

const addToCartFromListing = (pid, promoId, $productContainer) => {
    $.spinner().start();
    var form = {
        pid: pid,
        quantity: 1,
        options: [],
        promoId: promoId
    };
    var url = $('#tileAddToCartUrl').data('url');
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form,
        success: function (response) {
            if (response) {
                $('.js-mainHeader-minicart').trigger('count:update', response);
                localStorage.setItem('lastClickedPosition', '');
                localStorage.setItem('listtype', 'listing');
                // $("body, html").animate({ scrollTop: 0 }, 500, 'swing');
                $('body').trigger('product:afterAddToCart', {
                    ...response,
                    form,
                    $productContainer
                });
                $('body').trigger('product:afterQuickBuyListing', response);
            } else {
                console.error('Ajax: Empty Response');
            }
            $.spinner().stop();
        },
        error: function (err) {
            console.error('ErrorCase: ' + err.message);
            $.spinner().stop();
        }
    });
};

class QuickView {
    run () {
        this.showQuickview();
        this.observeQuickBuy();
    }

    showQuickview () {
        $('body').on('click', '.quickview', function (e) {
            e.stopPropagation();
            e.preventDefault();
            const selectedValueUrl = $(this).attr('href');
            const productUrl = selectedValueUrl.replace('Product-ShowQuickView', 'Product-Show');
            const modal = newModal(false, ['quickview-modal']);
            fillModalElement(productUrl, selectedValueUrl, modal);

            // trigger for analytics product detail event
            const target = $(this).closest('.product');
            if (target.length > 0) {
                $('body').trigger('product:analyticsProductDetails', target);
            }
        });
    }

    observeQuickBuy () {
        $('body').on('click', '.js-quick-buy-sizes-item-select', function (e) {
            e.preventDefault();
            if ($(this).hasClass('disable') || !$(this).data('variant')) {
                return false;
            }
            var url = $(this).data('variant');

            var pid = $(e.currentTarget).data('pid');
            $(`.js-quick-buy-sizes-item[data-pid="${pid}"]`).attr('variant', url);
        });
        $('body').on('click', '.js-quick-buy-sizes-item', function (e) {
            e.preventDefault();

            var url = $(this).attr('variant');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                success: function (response) {
                    $.spinner().stop();
                    const $productContainer = $(e.target);
                    if (response.product.available && !response.product.comingSoon) {
                        addToCartFromListing(response.product.id, false, $productContainer);
                    } else {
                        $('body').trigger('product:afterAddToCartFailed', {
                            ...response,
                            $productContainer
                        });
                    }
                },
                error: function (err) {
                    console.error('ErrorCase: ' + err.message);
                    $.spinner().stop();
                }
            });
        });
    }
}
// const quickView = new QuickView();
export default QuickView;
export { addToCartFromListing };
